export const B = 1
export const KB = B * 1024
export const MB = KB * 1000
export const GB = MB * 1000
